/**
 * 获取页面名
 * @returns 页面名
 */
function getPageName() {
  const pageReg = window.location.pathname.match(/\/([\w-_]+)\.html/);
  return pageReg ? pageReg[1] : '';
}


/**
 * 获取带标记的页面名, ares页面会带上页面标记
 * @returns 带标记的页面名
 */
function getPage() {
  const name = getPageName();
  if (name === 'ares') {
    const aresId = getAresID();
    return `ares-${aresId}`;
  }
  return name;
};

/**
 * 获取 Ares 页面的 ID
 * @returns ares id
 */
function getAresID() {
  const pageID = window.location.href.match(/PageID=(\d+)/);
  const confID = window.location.href.match(/ConfID=(\d+)/);
  const aresIDReg = pageID || confID || '';
  return aresIDReg ? aresIDReg[1] : '';
}


export default {
  getPageName,
  getAresID,
  getPage,
};
